import { render, staticRenderFns } from "./SelectVideoSource.vue?vue&type=template&id=1dc8d026&scoped=true&"
import script from "./SelectVideoSource.vue?vue&type=script&lang=js&"
export * from "./SelectVideoSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8d026",
  null
  
)

export default component.exports